import React from "react";
import PropTypes from "prop-types";
import styles from "@/components/CustomComponents/SiteMap/index.module.scss";
import { getLinkTarget } from "@/utils/helper";

const LinkListMapping = ({ links }) => {
  return (
    <ul className="space-y-2 text-sm text-[#337ab7] siteMapLinks">
      {links.map(
        (item, index) =>
          item.fields?.label !== "#" && (
            <li key={index}>
              {item.fields?.url ? (
                <a
                  target={getLinkTarget(item.fields?.url)}
                  href={item.fields?.url}
                  className="cursor-pointer hover:!no-underline text-[#337ab7] hover:!text-[#23527c]"
                >
                  {item.fields?.label}
                </a>
              ) : (
                <span className=" hover:!no-underline text-[#337ab7] hover:!text-[#23527c]">
                  {item.fields?.label}
                </span>
              )}
            </li>
          )
      )}
    </ul>
  );
};

const SiteMap = ({ siteMapData }) => {
  if (!siteMapData) return null;
  const { links: groupLinks = [], heading = "Site Map" } = siteMapData || {};
  const result = groupLinks.map(item => item?.fields);

  return (
    <div className={styles.wrapper}>
      <section className="bg-white py-10">
        <div className="site-map px-2">
          <h2 class="koh-simple-content-title">{heading}</h2>
        </div>
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid gap-5 md:gap-1 grid grid-cols-1 min-[768px]:grid-cols-2 min-[992px]:grid-cols-[repeat(auto-fill,250px)]">
            <div className="md:col-span-1 lg:col-span-4 w-[900px]">
              <div className="grid grid-cols-1 min-[992px]:grid-cols-4 gap-5 md:gap-[100px]">
                {result.map(
                  (section, index) =>
                    section.title !== "#" && (
                      <div key={index}>
                        <h3 className="text-sm font-[helveticaBold,_Helvetica,_sans-serif] font-[800] mb-3 text-black">
                          {section.title}
                        </h3>
                        <LinkListMapping links={section.links} />
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

SiteMap.propTypes = {
  siteMapData: PropTypes.object,
};

SiteMap.defaultProps = {
  siteMapData: {},
};

export default SiteMap;
